import { z } from 'zod';

export const recordedActionTextSchema = z.discriminatedUnion('state', [
  z.object({ state: z.literal('recorded'), text: z.string().min(1) }).strict(),
  z.object({ state: z.literal('not_recorded') }).strict(),
]);
export type RecordedActionText = z.infer<typeof recordedActionTextSchema>;

/** Optional source fields preserve older immutable records byte for byte. */
export const recordedActionHandoffFields = {
  catch: z.string().min(1).max(2000).optional(),
  firstCheckText: z.string().min(1).max(2000).optional(),
  firstCheck: z.discriminatedUnion('state', [
    z.object({ state: z.literal('scheduled'), date: z.string().date() }).strict(),
    z.object({ state: z.literal('not_yet_scheduled'), reason: z.literal('scheduling_not_set') }).strict(),
  ]).optional(),
};
